/* eslint-disable  react/display-name*/
import {
  Button,
  CircularProgress,
  IconButton,
  Tooltip,
  Typography,
  Grid,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import HomeIcon from "@mui/icons-material/Home";
import RefreshIcon from "@mui/icons-material/Refresh";
import SaveIcon from "@mui/icons-material/Save";

import MUIDataTable from "mui-datatables";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import API from "../../../utils/API";
import { StringUtils } from "../../../utils/StringUtils";
import ProductionCrud from "./productionCrud";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}
export default function ProductionList(props) {
  console.log("pppopopo", props.context.privileges.manufacturing_edit);
  const { t } = useTranslation();
  const translate = t;
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [rowLimitPerPage, setRowLimitPerPage] = useState(
    Math.round((getWindowDimensions().height - 162) / 33)
  );
  const [showProductionCrud, setShowProductionCrud] = useState(false);
  const [selectedProduction, setSelectedProduction] = useState(null);
  const [mode, setMode] = useState("");

  useEffect(() => {
    loadData("DRAFT");
  }, []);

  function addProduction() {
    setSelectedProduction(false);
    setShowProductionCrud(true);
    setMode("create");
    //biRef.quickEntry.showQuickPurchaseRequestWindow(null, "create", false);
  }

  function onEditClicked(row, updateValue, value, type) {
    setSelectedProduction(row.tableData[row.rowIndex].id);
    setShowProductionCrud(true);
    // setMode("edit");
    setMode(type);
  }

  // function onViewClicked(row, updateValue, value, type) {
  //   setSelectedProduction(row.tableData[row.rowIndex].id);
  //   setShowProductionCrud(true);
  //   setMode("view");
  // }

  async function loadData(status) {
    let sort = '[{id:"productionDate",sortOrder:"DESC"}]';
    let search = "[]";
    if (status) {
      let str = "[";
      str +=
        '{id:"status",value:"' +
        status +
        '",regExp:"",matchType:"EXACT_MATCH",operatorType:"",fieldValueType:"string"}]';
      search = str;
    }
    loadByRest(0, rowLimitPerPage, sort, search);
  }
  async function loadByRest(curPage, pageSize, sort, filter) {
    setIsLoading(true);
    const result = await API.get(
      "/api/v1/productions?range=" +
        encodeURIComponent(
          "[" + curPage * pageSize + "," + ((curPage + 1) * pageSize - 1) + "]"
        ) +
        "&filter=" +
        encodeURIComponent(filter) +
        "&sort=" +
        encodeURIComponent(sort)
    );

    var arr = result.headers["content-range"].split("/");

    const opt = { ...option };
    opt.count = parseInt(arr[2]);
    setOption(opt);
    setData(result.data.data);
    setIsLoading(false);
    console.log(result);
  }

  async function onTableChange(tableState) {
    let sort = '[{id:"productionDate",sortOrder:"DESC"}]';

    let search = "[";
    search +=
      '{id:"status",value:"' +
      (tableState.filterList[4][0]
        ? tableState.filterList[4][0]
        : tableState.filterList[3]) +
      '",regExp:"",matchType:"EXACT_MATCH",operatorType:"",fieldValueType:"string"}';

    if (tableState.searchText) {
      search +=
        ',{id:"productionNumber",value:"",regExp:"' +
        tableState.searchText +
        '",matchType:"BROAD_MATCH",operatorType:"",fieldValueType:"string","conditionType":"or"}';
    }
    search += "]";

    loadByRest(tableState.page, rowLimitPerPage, sort, search);
  }

  const options = {
    download: false,
    searchPlaceholder: "Search by Production Number",
    serverSide: true,
    searchable: true,
    viewColumns: false,
    filter: true,
    filterType: "dropdown",
    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,
    tableBodyMaxHeight: "100%",
    tableBodyHeight: getWindowDimensions().height - 162,
    rowsPerPage: Math.round((getWindowDimensions().height - 162) / 33),
    rowsPerPageOptions: [
      Math.round((getWindowDimensions().height - 162) / 33),
      10,
      15,
      50,
      100,
    ],
    print: false,
    onTableChange: (action, tableState) => {
      // a developer could react to change on an action basis or
      // examine the state as a whole and do whatever they want
      switch (action) {
        case "changePage":
          onTableChange(tableState);
          break;
        case "sort":
          onTableChange(tableState);
          break;
        case "changeRowsPerPage":
          onTableChange(tableState);
          break;
        case "search":
          onTableChange(tableState);
          break;
        case "filterChange":
          onTableChange(tableState);
          break;
        default:
        //console.log("action not handled." + action);
      }
    },
    customToolbar: () => {
      return (
        <React.Fragment>
          <Tooltip title={translate("Refresh Data")}>
            <IconButton size="small" color="primary" onClick={loadData}>
              <RefreshIcon />
            </IconButton>
          </Tooltip>

          <Tooltip title="Add Production">
            <IconButton size="small" color="secondary" onClick={addProduction}>
              <AddIcon />
            </IconButton>
          </Tooltip>
        </React.Fragment>
      );
    },
  };

  const [option, setOption] = useState(options);
  const columns = [
    {
      name: "productionDate",
      label: translate("Date"),
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "productionNumber",
      label: translate("Production Number"),
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "netQuantity",
      label: translate("Quantity"),
      options: {
        filter: false,
        sort: false,
      },
    },
    // {
    //   name: "strItems",
    //   label: translate("Items"),
    //   options: {
    //     filter: false,
    //     sort: false,
    //   },
    // },
    {
      name: "status",
      label: translate("Status"),
      options: {
        filter: true,
        sort: false,
        filterOptions: {
          names: ["DRAFT", "POSTED"],
        },
      },
    },
    {
      name: "description",
      label: translate("Note"),
      options: {
        filter: false,
        sort: false,
      },
    },
    {
      name: "action",
      label: translate("Actions"),
      options: {
        filter: false,
        sort: false,
        display: "true",
        setCellHeaderProps: () => ({ align: "center" }),
        setCellProps: () => ({ align: "center" }),
        customBodyRender: (value, tableMeta, updateValue) => (
          <div>
            <Button
              onClick={() =>
                onEditClicked(
                  tableMeta,
                  updateValue,
                  value,
                  tableMeta.tableData[tableMeta.rowIndex].status === "DRAFT" &&
                    (props.context.privileges.manufacturing_edit ||
                      props.context.privileges.manufacturing_delete)
                    ? "edit"
                    : "view"
                )
              }
              color="secondary"
              style={{
                margin: 0,
                padding: 0,
                height: 17,
                width: 27,
                alignText: "right",
              }}
            >
              {tableMeta.tableData[tableMeta.rowIndex].status == "DRAFT" &&
              props.context.privileges.manufacturing_edit
                ? translate("Edit")
                : translate("View")}
            </Button>
            {/* {tableMeta.tableData[tableMeta.rowIndex].status == "DRAFT" ? (
              <Button
                onClick={() =>
                  onEditClicked(tableMeta, updateValue, value, "Edit")
                }
                color="secondary"
                style={{
                  margin: 0,
                  padding: 0,
                  height: 17,
                  width: 27,
                  alignText: "right",
                }}
              >
                {translate("Edit")}
              </Button>
            ) : (
              <Button
                onClick={() =>
                  onViewClicked(tableMeta, updateValue, value, "View")
                }
                color="secondary"
                style={{
                  margin: 0,
                  padding: 0,
                  height: 17,
                  width: 27,
                  alignText: "right",
                }}
              >
                {translate("View")}
              </Button>
            )} */}
          </div>
        ),
      },
    },
  ];

  function purchaseorderListRefresh() {
    loadData("DRAFT");
  }

  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <div>
            <MUIDataTable
              title={
                <Typography variant="h6">
                  {translate("Production History")}
                  {isLoading && (
                    <CircularProgress
                      size={24}
                      style={{ marginLeft: 15, position: "relative", top: 4 }}
                    />
                  )}
                </Typography>
              }
              data={data}
              columns={columns}
              options={option}
            />
          </div>
        </Grid>
      </Grid>
      {showProductionCrud && (
        <ProductionCrud
          onRefreshList={loadData}
          mode={mode}
          showMessage={props.showMessage}
          productCache={props.productCache}
          context={props.context}
          setOpenWindow={setShowProductionCrud}
          selectedProduction={selectedProduction}
        ></ProductionCrud>
      )}
    </>
  );
}
